import React, { useState } from 'react';

import { Add, AddAlt, SubtractAlt } from '@carbon/icons-react';
import { Button, Divider, SearchInput } from '@varicent/components';

import TextButton from 'components/Buttons/TextButton/TextButton';
import { Menu } from 'components/menu/Menu';
import { MenuItem } from 'components/menu/MenuItem';
import Popover from 'components/Popover/Popover';

import block from 'utils/bem-css-modules';
import { formatMessage } from 'utils/messages/utils';

import style from './HierarchyAddMenu.module.pcss';

const b = block(style);

interface HierarchyAddMenu {
  hierarchies: { hierarchyId: number; hierarchyName: string }[];
  onSelectHierarchy: (hierarchy: { hierarchyId: number; hierarchyName: string }) => void;
  hierarchyAddedMap: Map<number, boolean>;
  onAddAll: () => void;
}

const HierarchyAddMenu: React.FC<HierarchyAddMenu> = ({
  hierarchies,
  onSelectHierarchy,
  hierarchyAddedMap,
  onAddAll
}) => {
  const [hierarchySearchValue, setHierarchySearchValue] = useState('');
  return (
    <Popover
      minimal
      usePortal={false}
      placement="bottom-start"
      content={
        <>
          <div className={b('hierarchyAddPopover')}>
            <SearchInput
              onClearValue={() => setHierarchySearchValue('')}
              value={hierarchySearchValue}
              onChange={(e) => setHierarchySearchValue(e.target.value)}
            />
          </div>
          <Menu className={b('hierarchyListMenu')} data-testid="hierarchy-list-menu">
            {hierarchies
              .filter((hierarchy) =>
                hierarchy.hierarchyName.toLocaleLowerCase().includes(hierarchySearchValue.toLocaleLowerCase())
              )
              .map((hierarchy) => (
                <MenuItem
                  key={hierarchy.hierarchyId}
                  className={b('hierarchyMenuItem')}
                  icon={hierarchyAddedMap.get(hierarchy.hierarchyId) ? <SubtractAlt /> : <AddAlt />}
                  data-testid={`hierarchy-menu-item-${hierarchy.hierarchyId}`}
                  text={hierarchy.hierarchyName}
                  onClick={() => onSelectHierarchy(hierarchy)}
                />
              ))}
            <Divider className={b('divider')} />
          </Menu>
          <TextButton
            className={b('addAllButton')}
            minimal
            type="button"
            testId="hierarchy-menu-add-all-btn"
            text={formatMessage('ADD_ALL')}
            onClick={onAddAll}
          />
        </>
      }
    >
      <Button data-testid={'open-menu-button'} icon={Add} text={formatMessage('HIERARCHY')} />
    </Popover>
  );
};

export default HierarchyAddMenu;
